import type { ChatItem } from '../../models/chat'
import type { InsuranceApplication } from '../../models/insuranceApplication'
import { EditBusinessDetailsDialog } from './EditBusinessDetailsDialog'
import { EditChatItemDialog } from './EditChatItemDialog'
import { EditDotNumberDialog } from './EditDotNumberDialog'
import { EditFreightDetailsDialog } from './EditFreightDetailsDialog'
import { EditOwnerInfoDialog } from './EditOwnerInfoDialog'

interface ChatEditDialogsProps {
  application: InsuranceApplication
  editingItem: ChatItem | null
  setEditingItem: (item: ChatItem | null) => void
  onEditSuccess: () => void
}

export function ChatEditDialogs({
  application,
  editingItem,
  setEditingItem,
  onEditSuccess,
}: ChatEditDialogsProps) {
  function handleClose(open: boolean) {
    if (!open) setEditingItem(null)
  }

  if (editingItem?.service === 'ADD_DOT_NUMBER') {
    return (
      <EditDotNumberDialog
        application={application}
        chatItem={editingItem}
        onOpenChange={handleClose}
        onSuccess={onEditSuccess}
      />
    )
  }

  if (editingItem?.service === 'CONFIRM_DOT_NUMBER' || editingItem?.service === 'CONFIRM_ENTITY_TYPE') {
    return (
      <EditBusinessDetailsDialog
        open={!!editingItem}
        onOpenChange={handleClose}
        onSuccess={onEditSuccess}
        business={application.business}
        entityType={application.entityType}
        hasEld={application.hasEld}
        eldProvider={application.eldProvider}
        orgId={application.orgId}
      />
    )
  }

  if (editingItem?.service === 'ADD_FREIGHT_SPECIFIC_ITEMS') {
    return (
      <EditFreightDetailsDialog
        open={!!editingItem}
        onOpenChange={handleClose}
        onSuccess={onEditSuccess}
        commodities={application.commodities}
        orgId={application.orgId}
      />
    )
  }

  if (editingItem?.service === 'CONFIRM_OWNER_INFO' || editingItem?.service === 'ADD_DOB') {
    return (
      <EditOwnerInfoDialog
        open={!!editingItem}
        onOpenChange={handleClose}
        onSuccess={onEditSuccess}
        owner={application.businessOwner ?? undefined}
        orgId={application.orgId}
      />
    )
  }

  return (
    <EditChatItemDialog
      application={application}
      chatItem={editingItem}
      onOpenChange={handleClose}
      onSuccess={onEditSuccess}
    />
  )
}
